import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import CommonModal from '../../atoms/modal/CommonModal'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { getPackages } from '../../../features/packageSlice'
import {
	getKazooProposals,
	updateProposalRequest,
} from '../../../features/proposalSlice'
import BudgetRange from '../../../pages/vendors-list/Modals/BudgetRange'

export default function EditProposalModal({
	open,
	handleClose,
	selectedKazoo,
	setSelectedKazoo,
}) {
	const dispatch = useDispatch()
	const [id, setId] = useState(null)
	const [selectedPackage, setSelectedPackage] = useState(null)

	useEffect(() => {
		if (open && selectedKazoo?.kid !== id) {
			setId(selectedKazoo?.kid)
			dispatch(getPackages({ vendorId: selectedKazoo?.vendorId }))
			const pkgId =
				selectedKazoo?.packageDetails?._id || selectedKazoo?.packageId
			const addOnsIds =
				selectedKazoo?.packageDetails?.addOns ||
				selectedKazoo?.packageDetails?.addOnsIds?.filter(
					(a) => a.isThisAddOnIsRequired
				) ||
				[]
			if (pkgId) {
				setSelectedPackage({
					...(selectedKazoo?.packageDetails || {}),
					_id: pkgId,
					addOnsIds,
					userBudget: selectedKazoo?.budget,
					selectedAddOns: [...addOnsIds?.map((a) => a._id)],
				})
			} else setSelectedPackage(null)
		}
	}, [open, selectedKazoo, dispatch])

	const handleSubmit = () => {
		const addOnIds = selectedPackage?.addOnsIds?.filter((addon) => {
			return selectedPackage?.selectedAddOns?.includes(addon?._id)
		})
		const payload = {
			packageId: selectedPackage?._id || null,
			userBudget: selectedKazoo?.userBudget,
			addOnIds:
				addOnIds?.map((addon) => {
					return {
						id: addon?._id,
						quantity: addon?.quantity || addon?.minQuantity || 1,
					}
				}) || [],
			proposalId: selectedKazoo?.id || selectedKazoo?._id,
			serviceRequirements: selectedKazoo?.serviceRequirements,
		}

		dispatch(updateProposalRequest(payload)).then((res) => {
			if (res?.payload?.success) {
				if (selectedKazoo?.kazooId)
					dispatch(getKazooProposals(selectedKazoo.kazooId))
				handleClose()
			}
		})
	}

	return (
		<CommonModal
			open={open}
			handleClose={handleClose}
			heading="Edit Proposal"
			footerContent={
				<>
					<ButtonCustom
						onClick={handleClose}
						variant="outlined"
						size="lg"
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						onClick={handleSubmit}
						variant="default"
						size="lg"
					>
						Save Changes
					</ButtonCustom>
				</>
			}
		>
			<BudgetRange
				selectedKazoo={selectedKazoo}
				selectedPackage={selectedPackage}
				setSelectedKazoo={setSelectedKazoo}
				setSelectedPackage={setSelectedPackage}
			/>
		</CommonModal>
	)
}
